export class CustomEventHandler extends EventTarget {

    subscribe(eventName: any, cb: (this: Window, ev: any) => any) {
        window.addEventListener(eventName, cb);
    }

    unsubscribe(eventName: any, cb: (this: Window, ev: any) => any) {
        window.removeEventListener(eventName, cb);
    }

    emit(eventName: string, payload: any) {
        window.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
    }
}

export const EventHandler = new CustomEventHandler();
